import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApplicationResponse } from "@src/common/domain/common.model";
import api from "@src/common/services/api.service";
import AppConstants from "@src/utils/app.constants";
import { DependencyModelRef, TaskModelRef } from "@src/views/project-tasks/domain/task.model";
import { RemarksModelRef, RemarksStore } from "../domain/task.model";
import {showErrorToast} from "@utils/toast.utils";

export const updateTaskBasicDetails = createAsyncThunk<
  void,
  { taskId: string,payload:any,shouldReload? : boolean  }
>("task/details", async ({ taskId,payload,shouldReload=false }) => {
  const url = `${AppConstants.api}/task/details/${taskId}`;
  const response = await api.put<ApplicationResponse<TaskModelRef>>(url, payload,{
    params:{
      RAR: shouldReload
    }
  });
  return ;
});

export const markTaskNotApplicable = createAsyncThunk<
  void,
  { taskId: string; status: boolean , task_status?: any}
>("task/notApplicable", async ({ taskId, status,task_status }) => {
  const url = `${AppConstants.api}/task/not_applicable`; 

  await api.put<void>(url, null, {
    params: {
      id: taskId,
      status: status,
      task_status,
      RAR:0
    },
  });
  
  return;
});


export const createSubtask = createAsyncThunk<
  any,
  { taskId: string; payload: any }
>("task/create-subtask", async ({ taskId, payload }) => {
  const url = `${AppConstants.api}/task/create-subtask/${taskId}`;
  const response = await api.put<ApplicationResponse<TaskModelRef>>(
    url,
    payload,{
      params:{
      RAR: 0
    }
    }
  );
  return response.data.data;
});
export const createDependency = createAsyncThunk<
  any,
  { payload: DependencyModelRef }
>("task/create-dependency", async ({ payload }) => {
  const url = `${AppConstants.api}/dependency`;
  const response = await api.post<ApplicationResponse<DependencyModelRef>>(
    url,
    payload,{
    params:{
      RAR: 0
    }
  }
  );
  return response.data.data;
});
export const updateDependency = createAsyncThunk<
  any,
  { payload: DependencyModelRef,id:string }
>("task/update-dependency", async ({ payload,id }) => {
  const url = `${AppConstants.api}/dependency/${id}`;
  const response = await api.put<ApplicationResponse<DependencyModelRef>>(
    url,
    payload
  );
  return response.data.data;
});

export const deleteDependency = createAsyncThunk<
  void,
  { id: string;}
>("task/renove-dependency", async ({ id}) => {
  const url = `${AppConstants.api}/dependency/${id}`;
  const response = await api.delete<ApplicationResponse<void>>(url,
    {
    params:{
      RAR: 0
    }
  }
  );
  return;
});

export const removeSubtask = createAsyncThunk<
  void,
  { taskId: string;}
>("task/renove-subtask", async ({ taskId}) => {
  const url = `${AppConstants.api}/task/delete/${taskId}`;
  const response = await api.delete<ApplicationResponse<TaskModelRef>>(url);
  return;
});

export const calculateEndDate = async (startDate: string, duration: number) => {
    if (startDate && duration) {
        try {
            const response = await api.get(`${AppConstants.api}/task/end-date`, {
                params: {
                    start_date: startDate,
                    duration: duration,
                },
            });
            return response.data.data;
        } catch (error) {
            showErrorToast("Failed to calculate end date");
        }
    }
    return;
};

export const fetchRemarksList = createAsyncThunk<any[], {id:string}> ("remarks/fetchRemarks",
    async ({id}) => {
        const response = await api.get<ApplicationResponse<RemarksModelRef[]>>(`${AppConstants.api}/task/${id}/remarks`)
        return response.data.data || []  
    })

const RemarksSlice = createSlice({
    name: "remarks",
    initialState: {minimal: {status: "loading", error: null, data: []}} as RemarksStore ,
    reducers: {

    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchRemarksList.pending, (state, action) => {
                state.minimal = {
                    status: "loading",
                    data: [],
                    error: null
                }
            })
            .addCase(fetchRemarksList.fulfilled, (state, action) => {
                state.minimal = {
                    status: "idle",
                    data: action.payload,
                    error: null
                }
            })
            .addCase(fetchRemarksList.rejected, (state, action) => {
                state.minimal = {
                    status: "failed",
                    data: [],
                    error: action.error
                }
            })
           
    }
})

export default RemarksSlice.reducer